import { clearPasswordResetFlags } from "./PasswordResetFlags";

export const saveItem = (key, value) => {
    localStorage.setItem(key, value)
}

export const getItem = (key) => {
    return localStorage.getItem(key);
}

export const removeItem = (key) => {
    localStorage.removeItem(key);
}

/**
 * Stores the signed-in user's timezone for THIS TAB. Every login path calls this;
 * sessionStorage starts empty in each new tab, so loadByUsername is what repopulates it
 * after a refresh.
 */
export const storeUserTimeZone = (tz, { clearWhenMissing = false } = {}) => {
    // "__SYSTEM__" is the PreferenceSetting sentinel for "use the browser zone"; it is not a
    // real IANA zone and must never reach moment.tz().
    const missing = tz === null || tz === undefined || tz === "" ||
        tz === "null" || tz === "undefined" || tz === "__SYSTEM__";
    try {
        if (missing) {
            if (clearWhenMissing) {
                sessionStorage.removeItem("userTimeZone");
                console.warn("[tz] preference cleared - dates now use the browser zone");
            } else {
                console.warn("[tz] login response carried no timezone - keeping existing value");
            }
            return;
        }
        sessionStorage.setItem("userTimeZone", tz);
        console.warn("[tz] userTimeZone stored ->", tz);
    } catch (e) {
        // Private mode / blocked storage - dates fall back to the browser zone.
        console.warn("[tz] could not store userTimeZone", e);
    }
}

/**
 * Keys that must OUTLIVE a logout. Everything else in localStorage is cleared.
 *
 * A keep-list rather than a remove-list on purpose: any key added later is cleared
 * automatically, so this cannot silently fall out of date.
 *
 * OLD: Do NOT use localStorage.clear() here - it would wipe amplitude_*, which the analytics
 * OLD: SDK owns and whose removal drops unsent events.
 * NEW: amplitude_* is no longer kept - Amplitude was removed (DTK-8010) and its init() is
 * never called, so the SDK never writes an amplitude_* key. Nothing is kept at logout now.
 */
// theme is deliberately NOT kept: logout() already removed it, so clearing it here
// preserves today's behaviour rather than quietly changing it.
// OLD: const KEEP_ON_LOGOUT = ["md", "userTimeZone"];
// OLD: const KEEP_ON_LOGOUT = ["userTimeZone"];
// "md" is gone entirely - it was only ever echoed into a backend log line, never stored
// or used for authorization or session tracking.
const KEEP_ON_LOGOUT = [];
// OLD: const KEEP_PREFIXES = ["amplitude_"];
const KEEP_PREFIXES = [];

/**
 * Clears per-user state from localStorage at logout, so nothing from one session is
 * visible to the next person on a shared workstation.
 */
export const clearUserStorage = () => {
    // VAPT: the password-reset flags live in memory now (no longer in localStorage), so clear
    // them here too - this is the single logout path (logout, logout-all, failed refresh).
    clearPasswordResetFlags();
    try {
        Object.keys(localStorage).forEach((key) => {
            if (KEEP_ON_LOGOUT.includes(key)) return;
            if (KEEP_PREFIXES.some((prefix) => key.startsWith(prefix))) return;
            localStorage.removeItem(key);
        });
        // OTP details now live in sessionStorage; clear them on the way out too.
        sessionStorage.clear();
        console.warn("[logout] user storage cleared");
    } catch (e) {
        // Private mode / blocked storage - never let this stop the logout.
        console.warn("[logout] could not clear storage", e);
    }
}